(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-filter-bar"] && !Shopify.designMode) return;
  try {
    
(function() {
  var bar = document.querySelector('[data-cm-filterbar]');
  if (!bar) return;

  function getActiveTags() {
    var params = new URLSearchParams(window.location.search);
    return params.getAll('filter.p.tag');
  }

  function buildUrl(tags) {
    var url = new URL(window.location.href);
    url.searchParams.delete('filter.p.tag');
    url.searchParams.delete('page');
    tags.forEach(function(t) {
      url.searchParams.append('filter.p.tag', t);
    });
    return url.toString();
  }

  function updatePills(activeTags) {
    bar.querySelectorAll('[data-tag]').forEach(function(pill) {
      var tag = pill.dataset.tag;
      if (activeTags.includes(tag)) {
        pill.classList.add('cm-filterbar__pill--active');
        pill.setAttribute('aria-pressed', 'true');
      } else {
        pill.classList.remove('cm-filterbar__pill--active');
        pill.setAttribute('aria-pressed', 'false');
      }
    });
  }

  bar.querySelectorAll('[data-tag]').forEach(function(pill) {
    pill.addEventListener('click', function(e) {
      e.preventDefault();
      var tag = this.dataset.tag;
      var activeTags = getActiveTags();
      var idx = activeTags.indexOf(tag);
      if (idx > -1) {
        activeTags.splice(idx, 1);
      } else {
        activeTags.push(tag);
      }
      updatePills(activeTags);
      window.location.href = buildUrl(activeTags);
    });
  });

  updatePills(getActiveTags());
})();

  } catch(e) { console.error(e); }
})();
})();
